import React, { RefObject, useEffect, useRef, useState } from "react";

import MergeIcon from "assets/home/open-source-timeline/merge-icon.svg";
import DotIcon from "assets/home/open-source-timeline/dot-icon.svg";

import styles from "./OpenSourceTimeline.module.css";

type Entry = [string, string];

const USERS = ["Petr", "Sandy", "Imthath", "Artem", "Stuart", "Remon"];
const GENERATORS = [
  (): Entry => [DotIcon, `${randomUser()} added a feature request`],
  (): Entry => [MergeIcon, `${randomUser()} added the ${randomExtension()} extension`],
  (): Entry => [DotIcon, `${randomUser()} reported a bug`],
];
const EXTENSIONS = ["Search Recent Projects", "Stand Up", "Slack Status", "Spotify", "Dash"];

const randomUser = () => USERS[Math.floor(Math.random() * USERS.length)];
const randomExtension = () => EXTENSIONS[Math.floor(Math.random() * EXTENSIONS.length)];

const randomEntry = (): Entry => GENERATORS[Math.floor(Math.random() * GENERATORS.length)]();

const useTimeline = (listRef: RefObject<HTMLUListElement>) => {
  const [timeline, setTimeline] = useState<Entry[]>([]);
  const intervalRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    setTimeline([randomEntry(), randomEntry(), randomEntry(), randomEntry(), randomEntry()]);

    intervalRef.current = setInterval(() => {
      if (!listRef.current) return;
      const cssTopMatch = getComputedStyle(listRef.current).top.match(/(-?\d+)px/);

      if (!Array.isArray(cssTopMatch)) return;

      const computedTop = cssTopMatch[1];

      setTimeline((t) => [...t, randomEntry()]);
      listRef.current.style.top = `${parseInt(computedTop, 10) - 78}px`;
    }, 2500);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [listRef]);

  return timeline;
};

const OpenSourceTimeline: React.FC = () => {
  const listRef = useRef<HTMLUListElement>(null);
  const timeline = useTimeline(listRef);

  return (
    <div className={styles.wrapper}>
      <ul ref={listRef}>
        {timeline.map(([Icon, value], index) => (
          <li key={index}>
            <Icon />
            <span>{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OpenSourceTimeline;
